/**
 * Formats a date string to a readable format
 * @param dateString - The date string to format
 * @returns Formatted date string
 */
export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

/**
 * Formats a date to a short format (MM/DD/YYYY)
 * @param dateString - The date string to format
 * @returns Short formatted date string
 */
export const formatShortDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  });
};

/**
 * Formats a login time to DD-MM-YYYY HH:MM format
 * @param dateString - The date string to format (ISO format like 2025-07-01T11:47:10.349Z)
 * @returns Formatted date string in DD-MM-YYYY HH:MM format
 */
export const formatLoginTime = (dateString: string): string => {
  if (!dateString) return 'N/A';

  const date = new Date(dateString);

  // Check if the date is valid
  if (isNaN(date.getTime())) {
    return 'Invalid Date';
  }

  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');

  return `${day}-${month}-${year} ${hours}:${minutes}`;
};

/**
 * Gets the current timestamp
 * @returns Current timestamp as number
 */
export const getCurrentTimestamp = (): number => {
  return Date.now();
};

/**
 * Checks if a date is today
 * @param dateString - The date string to check
 * @returns True if the date is today
 */
export const isToday = (dateString: string): boolean => {
  const date = new Date(dateString);
  const today = new Date();
  return date.toDateString() === today.toDateString();
};
